<template>
  <header>
    <div class="container-xxl pt-3 pb-3">
      <div class="header-box d-flex justify-content-between align-items-center">
        <div class="logo-box">
          <router-link to="/" class="logo-link" title="SUPER AVATAR">
            <img class="logo" alt="logo.png" src="../assets/images/logo.png" />
          </router-link>
          <!--
          <div class="co-branded d-inline-block align-middle">
            <img class="co-logo" src="../assets/images/lifeform_logo.png" />
            <svg class="ms-1 me-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path d="M571.733333 512l268.8-268.8c17.066667-17.066667 17.066667-42.666667 0-59.733333-17.066667-17.066667-42.666667-17.066667-59.733333 0L512 452.266667 243.2 183.466667c-17.066667-17.066667-42.666667-17.066667-59.733333 0-17.066667 17.066667-17.066667 42.666667 0 59.733333L452.266667 512 183.466667 780.8c-17.066667 17.066667-17.066667 42.666667 0 59.733333 8.533333 8.533333 19.2 12.8 29.866666 12.8s21.333333-4.266667 29.866667-12.8L512 571.733333l268.8 268.8c8.533333 8.533333 19.2 12.8 29.866667 12.8s21.333333-4.266667 29.866666-12.8c17.066667-17.066667 17.066667-42.666667 0-59.733333L571.733333 512z" fill="#000000"></path></svg>
            <img class="co-logo" src="../assets/images/hooked_logo.png" />
            <svg class="ms-1 me-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path d="M571.733333 512l268.8-268.8c17.066667-17.066667 17.066667-42.666667 0-59.733333-17.066667-17.066667-42.666667-17.066667-59.733333 0L512 452.266667 243.2 183.466667c-17.066667-17.066667-42.666667-17.066667-59.733333 0-17.066667 17.066667-17.066667 42.666667 0 59.733333L452.266667 512 183.466667 780.8c-17.066667 17.066667-17.066667 42.666667 0 59.733333 8.533333 8.533333 19.2 12.8 29.866666 12.8s21.333333-4.266667 29.866667-12.8L512 571.733333l268.8 268.8c8.533333 8.533333 19.2 12.8 29.866667 12.8s21.333333-4.266667 29.866666-12.8c17.066667-17.066667 17.066667-42.666667 0-59.733333L571.733333 512z" fill="#000000"></path></svg>
            <img class="co-logo" src="../assets/images/bnb_chain_logo.png" />
          </div>
          -->
          <div v-if="coImgId" class="co-branded d-inline-block align-middle">
            <img class="co-logo" :src="'https://cdn.lifeform.cc/super-avatar/collaborate/' + coImgId + '.png'" />
          </div>
        </div>
        <div class="d-flex">
          <NetworkDelay :address="walletState.address" class="me-3" />
          <button class="toggle-nav-btn btn position-relative" @click="() => showNav = !showNav">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M92 92l840 0C965.104 92 992 118.864 992 152c0 33.136-26.896 60-60 60L92 212C58.864 212 32 185.136 32 152 32 118.864 58.864 92 92 92z" p-id="15496" fill="#000000"></path><path d="M92 452l840 0c33.104 0 60 26.864 60 60 0 33.104-26.896 60-60 60L92 572C58.864 572 32 545.104 32 512 32 478.864 58.864 452 92 452z" p-id="15497" fill="#000000"></path><path d="M92 812l840 0c33.104 0 60 26.896 60 60s-26.896 60-60 60L92 932C58.864 932 32 905.104 32 872S58.864 812 92 812z" fill="#000000"></path></svg>
          </button>
        </div>
        <div :class="'nav-box ' + (showNav ? 'd-flex' : 'd-none')">
          <div class="nav-space" @click="() => showNav = false"></div>
          <nav class="nav d-flex align-items-center">
            <button class="toggle-nav-btn btn position-absolute" @click="() => showNav = !showNav">
              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M571.733333 512l268.8-268.8c17.066667-17.066667 17.066667-42.666667 0-59.733333-17.066667-17.066667-42.666667-17.066667-59.733333 0L512 452.266667 243.2 183.466667c-17.066667-17.066667-42.666667-17.066667-59.733333 0-17.066667 17.066667-17.066667 42.666667 0 59.733333L452.266667 512 183.466667 780.8c-17.066667 17.066667-17.066667 42.666667 0 59.733333 8.533333 8.533333 19.2 12.8 29.866666 12.8s21.333333-4.266667 29.866667-12.8L512 571.733333l268.8 268.8c8.533333 8.533333 19.2 12.8 29.866667 12.8s21.333333-4.266667 29.866666-12.8c17.066667-17.066667 17.066667-42.666667 0-59.733333L571.733333 512z" p-id="16816" fill="#000000"></path></svg>
            </button>
            <div class="menu d-flex">
              <a class="nav-item font-poppins-bold btn btn-outline-dark pt-2 pb-1 me-3" href="https://lifeform.cc" target="_blank">
                <svg class="align-middle me-1 mb-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="19" height="19"><path d="M925.866667 396.8l-32-27.733333c-78.933333-66.133333-185.6-157.866667-320-273.066667l-12.8-10.666667C533.333333 61.866667 490.666667 61.866667 462.933333 85.333333l-151.466666 130.133334c-85.333333 72.533333-155.733333 132.266667-211.2 179.2-17.066667 12.8-25.6 32-25.6 53.333333v4.266667c2.133333 38.4 34.133333 66.133333 70.4 66.133333H192v358.4c0 29.866667 23.466667 53.333333 53.333333 53.333333h164.266667c27.733333-2.133333 49.066667-25.6 49.066667-53.333333v-185.6c0-12.8 8.533333-21.333333 21.333333-21.333333h64c12.8 0 21.333333 8.533333 21.333333 21.333333v185.6c0 29.866667 23.466667 53.333333 53.333334 53.333333h164.266666c27.733333-2.133333 49.066667-25.6 49.066667-53.333333V518.4h46.933333c38.4 0 70.4-32 70.4-70.4 0-21.333333-8.533333-38.4-23.466666-51.2z"></path></svg>
                <span class="align-middle">LIFEFORM</span>
              </a>
              <router-link v-if="walletState.address" class="nav-item font-poppins-bold btn btn-outline-dark pt-2 pb-1 me-3" to="referral">
                <svg class="align-middle me-1 mb-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M960 651.07v119.47c-0.21 63.21-51.4 114.41-114.61 114.61H476.91c-63.21-0.21-114.41-51.4-114.61-114.61V651.07c1.46-46.4 29.5-87.82 72.05-106.4a605.155 605.155 0 0 1 453.6 0c42.54 18.57 70.59 59.99 72.05 106.4zM661.33 437.52c82.47 0 149.33-66.86 149.33-149.33S743.8 138.86 661.33 138.86 512 205.71 512 288.19s66.86 149.33 149.33 149.33zM400 474.85c20.62 0 37.33-16.71 37.33-37.33 0-20.62-16.72-37.33-37.33-37.33H288v-112c0-20.62-16.71-37.33-37.33-37.33s-37.33 16.71-37.33 37.33v112h-112C80.72 400.19 64 416.9 64 437.52c0 20.62 16.72 37.33 37.33 37.33h112v112c0 20.62 16.72 37.33 37.33 37.33S288 607.47 288 586.85v-112h112z"></path></svg>
                <span class="align-middle">{{$t('header.referral')}}</span>
              </router-link>
              <button v-else class="nav-item font-poppins-bold btn btn-outline-dark pt-2 pb-1 me-3" @click="connectWallet('/referral')">
                <svg class="align-middle me-1 mb-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M960 651.07v119.47c-0.21 63.21-51.4 114.41-114.61 114.61H476.91c-63.21-0.21-114.41-51.4-114.61-114.61V651.07c1.46-46.4 29.5-87.82 72.05-106.4a605.155 605.155 0 0 1 453.6 0c42.54 18.57 70.59 59.99 72.05 106.4zM661.33 437.52c82.47 0 149.33-66.86 149.33-149.33S743.8 138.86 661.33 138.86 512 205.71 512 288.19s66.86 149.33 149.33 149.33zM400 474.85c20.62 0 37.33-16.71 37.33-37.33 0-20.62-16.72-37.33-37.33-37.33H288v-112c0-20.62-16.71-37.33-37.33-37.33s-37.33 16.71-37.33 37.33v112h-112C80.72 400.19 64 416.9 64 437.52c0 20.62 16.72 37.33 37.33 37.33h112v112c0 20.62 16.72 37.33 37.33 37.33S288 607.47 288 586.85v-112h112z"></path></svg>
                <span class="align-middle">{{$t('header.referral')}}</span>
              </button>
              <div class="nav-item wallet-box position-relative me-3">
                <button v-if="!walletState.address" class="font-poppins-bold btn btn-outline-dark pt-2 pb-1" @click="connectWallet('')">
                  <span v-if="walletState.loginLoading" class="spinner-border spinner-border-sm me-2"></span>
                  <svg v-else class="align-middle me-1 mb-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M639.42656 204.8a61.44 61.44 0 0 1 61.44 61.44l-0.02048 41.86112h62.54592a61.44 61.44 0 0 1 61.44 61.44l-0.02048 103.85408H535.57248v165.29408h289.23904v103.85408a61.44 61.44 0 0 1-61.44 61.44H245.76a61.44 61.44 0 0 1-61.44-61.44V307.2a102.4 102.4 0 0 1 102.4-102.4h352.70656z m182.86592 330.0352v42.41408h-225.28v-42.3936h225.28zM639.3856 266.24H286.72a40.96 40.96 0 0 0-40.96 40.96l-0.02048 0.90112h393.66656V266.24z"></path></svg>
                  <span class="align-middle">{{$t('header.connect')}}</span>
                </button>
                <button v-else :class="'wallet-addr-btn font-poppins-bold btn pt-2 pb-1 ps-3 pe-3 ' + (walletState.showDropdown ? 'btn-dark dropwodn-open' : 'btn-outline-dark')" @click.stop="() => walletState.showDropdown = !walletState.showDropdown">
                  <svg class="align-middle me-1 mb-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="22"><path d="M639.42656 204.8a61.44 61.44 0 0 1 61.44 61.44l-0.02048 41.86112h62.54592a61.44 61.44 0 0 1 61.44 61.44l-0.02048 103.85408H535.57248v165.29408h289.23904v103.85408a61.44 61.44 0 0 1-61.44 61.44H245.76a61.44 61.44 0 0 1-61.44-61.44V307.2a102.4 102.4 0 0 1 102.4-102.4h352.70656z m182.86592 330.0352v42.41408h-225.28v-42.3936h225.28zM639.3856 266.24H286.72a40.96 40.96 0 0 0-40.96 40.96l-0.02048 0.90112h393.66656V266.24z"></path></svg>
                  <span class="align-middle">{{walletState.address.substr(0, 5) + '...' + walletState.address.substr(walletState.address.length - 4, 4)}}</span>
                  <svg class="ms-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="117833" width="18" height="18"><path d="M904.533333 311.466667c-17.066667-17.066667-42.666667-17.066667-59.733333 0L512 644.266667 179.2 311.466667c-17.066667-17.066667-42.666667-17.066667-59.733333 0-17.066667 17.066667-17.066667 42.666667 0 59.733333l362.666666 362.666667c8.533333 8.533333 19.2 12.8 29.866667 12.8s21.333333-4.266667 29.866667-12.8l362.666666-362.666667c17.066667-17.066667 17.066667-42.666667 0-59.733333z"></path></svg>
                </button>
                <div v-if="walletState.address && walletState.showDropdown" class="wallet-dropdown-menu bg-dark w-100 position-absolute overflow-hidden">
                  <!--
                  <div v-if="walletState.balanceTxt != null" class="btn btn-dark text-start w-100 p-1" style="white-space: nowrap;" @click.stop>
                    <svg class="ms-2" viewBox="0 0 1156 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M942.495603 0H214.266516A215.151597 215.151597 0 0 0 0 213.419917v597.121684a215.151597 215.151597 0 0 0 214.266516 213.458399h728.229087a215.151597 215.151597 0 0 0 214.266517-213.458399V213.419917A214.304998 214.304998 0 0 0 942.495603 0z m128.798497 640.298234H686.130026a128.336716 128.336716 0 1 1 0-256.63495h385.164074zM686.130026 298.541601a213.419917 213.419917 0 1 0 0 426.878316h385.164074v85.121684a129.029387 129.029387 0 0 1-128.798497 128.298234H214.266516a129.029387 129.029387 0 0 1-128.798496-128.298234V213.419917a129.029387 129.029387 0 0 1 128.798496-128.298233h728.229087a129.029387 129.029387 0 0 1 128.798497 128.298233v85.121684z" p-id="4361" fill="#ffffff"></path><path d="M642.799549 512a43.368959 43.368959 0 1 0 43.368959-43.215032 43.753777 43.753777 0 0 0-43.368959 43.215032z" fill="#ffffff"></path></svg>
                    <span class="align-middle ms-1">{{walletState.balanceTxt}}</span>
                  </div>
                  -->
                  <div v-if="walletState.point !== null" class="btn btn-dark text-start w-100 p-1" style="white-space: nowrap;" @click.stop>
                    <svg class="ms-2" viewBox="0 0 1156 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M942.495603 0H214.266516A215.151597 215.151597 0 0 0 0 213.419917v597.121684a215.151597 215.151597 0 0 0 214.266516 213.458399h728.229087a215.151597 215.151597 0 0 0 214.266517-213.458399V213.419917A214.304998 214.304998 0 0 0 942.495603 0z m128.798497 640.298234H686.130026a128.336716 128.336716 0 1 1 0-256.63495h385.164074zM686.130026 298.541601a213.419917 213.419917 0 1 0 0 426.878316h385.164074v85.121684a129.029387 129.029387 0 0 1-128.798497 128.298234H214.266516a129.029387 129.029387 0 0 1-128.798496-128.298234V213.419917a129.029387 129.029387 0 0 1 128.798496-128.298233h728.229087a129.029387 129.029387 0 0 1 128.798497 128.298233v85.121684z" p-id="4361" fill="#ffffff"></path><path d="M642.799549 512a43.368959 43.368959 0 1 0 43.368959-43.215032 43.753777 43.753777 0 0 0-43.368959 43.215032z" fill="#ffffff"></path></svg>
                    <span class="align-middle ms-1 text-uppercase">{{$t('common.point')}}: {{walletState.point}}</span>
                  </div>
                  <router-link class="btn btn-dark text-start w-100 p-1" to="/records">
                    <svg class="ms-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M800 384c0-160-128-288-288-288s-288 128-288 288c0 108.8 57.6 201.6 147.2 249.6-121.6 48-214.4 153.6-240 288-3.2 16 6.4 35.2 25.6 38.4h6.4c16 0 28.8-9.6 32-25.6 28.8-150.4 160-259.2 313.6-262.4h6.4c156.8 0 284.8-128 284.8-288zM288 384c0-124.8 99.2-224 224-224s224 99.2 224 224c0 121.6-99.2 220.8-220.8 224H505.6C384 604.8 288 505.6 288 384zM723.2 675.2c-16-9.6-35.2-6.4-44.8 9.6-9.6 16-6.4 35.2 9.6 44.8 73.6 51.2 124.8 121.6 140.8 204.8 3.2 16 16 25.6 32 25.6h6.4c16-3.2 28.8-19.2 25.6-38.4-19.2-99.2-80-185.6-169.6-246.4z" fill="#ffffff"></path></svg>
                    <span class="align-middle ms-1">{{$t('header.records')}}</span>
                  </router-link>
                  <router-link class="btn btn-dark text-start w-100 p-1" to="/register_records">
                    <svg class="ms-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M768 128h-50.101333C700.288 78.314667 653.045333 42.666667 597.333333 42.666667H426.666667c-55.712 0-102.954667 35.648-120.565334 85.333333H256c-70.72 0-128 57.28-128 128v597.333333c0 70.72 57.28 128 128 128h512c70.72 0 128-57.28 128-128V256c0-70.72-57.28-128-128-128z m-341.333333 0h170.666666a42.666667 42.666667 0 0 1 0 85.333333H426.666667a42.666667 42.666667 0 0 1 0-85.333333z m384 725.333333c0 23.573333-19.093333 42.666667-42.666667 42.666667H256c-23.573333 0-42.666667-19.093333-42.666667-42.666667V256c0-23.573333 19.093333-42.666667 42.666667-42.666667h50.101333c17.578667 49.685333 64.853333 85.333333 120.565334 85.333334h170.666666c55.712 0 102.954667-35.648 120.565334-85.333334H768c23.573333 0 42.666667 19.093333 42.666667 42.666667v597.333333z" fill="#ffffff"></path></svg>
                    <span class="align-middle ms-1">{{$t('header.register')}}</span>
                  </router-link>
                  <button class="btn btn-dark text-start w-100 p-1" @click="disconnectWallet">
                    <svg class="ms-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M835.669333 554.666667h-473.173333A42.453333 42.453333 0 0 1 320 512a42.666667 42.666667 0 0 1 42.474667-42.666667h473.173333l-161.813333-161.834666a42.666667 42.666667 0 0 1 60.330666-60.330667l234.666667 234.666667a42.666667 42.666667 0 0 1 0 60.330666l-234.666667 234.666667a42.666667 42.666667 0 0 1-60.330666-60.330667L835.669333 554.666667zM554.666667 42.666667a42.666667 42.666667 0 1 1 0 85.333333H149.525333C137.578667 128 128 137.578667 128 149.482667v725.034666C128 886.4 137.6 896 149.525333 896H554.666667a42.666667 42.666667 0 1 1 0 85.333333H149.525333A106.816 106.816 0 0 1 42.666667 874.517333V149.482667A106.773333 106.773333 0 0 1 149.525333 42.666667H554.666667z" fill="#ffffff"></path></svg>
                    <span class="align-middle ms-1">{{$t('header.disconnect')}}</span>
                  </button>
                </div>
              </div>
              <div class="nav-item lang-box d-inline-block position-relative" @mouseenter="() => langState.showList = true" @mouseleave="() => langState.showList = false">
                <button :class="'nav-item lang-toggle-btn font-poppins-bold btn pt-2 pb-1 ' + (langState.showList ? 'btn-dark' : 'btn-outline-dark')">
                  <svg class="align-middle me-1 mb-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M512 128a384 384 0 1 0 384 384A384 384 0 0 0 512 128z m258.346667 234.666667h-101.12a542.933333 542.933333 0 0 0-37.546667-124.16 301.653333 301.653333 0 0 1 138.666667 124.16zM810.666667 512a301.653333 301.653333 0 0 1-7.04 64h-123.52c2.56-21.333333 2.56-42.666667 2.56-64s-1.066667-42.666667-2.56-64h123.52a301.653333 301.653333 0 0 1 7.04 64zM512 810.666667c-17.28-8.32-50.773333-59.093333-70.186667-149.333334h140.373334c-19.413333 89.813333-52.906667 140.586667-70.186667 149.333334z m-82.773333-234.666667Q426.666667 545.92 426.666667 512t2.56-64h165.546666q2.56 30.08 2.56 64t-2.56 64zM213.333333 512a301.653333 301.653333 0 0 1 7.04-64h123.52c-1.493333 21.333333-2.56 42.666667-2.56 64s1.066667 42.666667 2.56 64h-123.52a301.653333 301.653333 0 0 1-7.04-64z m298.666667-298.666667c17.28 8.32 50.773333 59.093333 70.186667 149.333334h-140.373334c19.413333-89.813333 52.906667-140.586667 70.186667-149.333334z m-119.68 24.746667A542.933333 542.933333 0 0 0 354.773333 362.666667h-101.12a301.653333 301.653333 0 0 1 138.666667-124.16zM253.653333 661.333333h101.12a542.933333 542.933333 0 0 0 37.546667 124.16 301.653333 301.653333 0 0 1-138.666667-124.16z m378.026667 124.16A542.933333 542.933333 0 0 0 669.226667 661.333333h101.12a301.653333 301.653333 0 0 1-138.666667 124.16z"></path></svg>
                  <span class="align-middle text-uppercase">{{langState.current.substr(0, 2)}}</span>
                </button>
                <div v-if="langState.showList" class="lang-list-box position-absolute pt-2">
                  <div class="lang-list w-100">
                    <button v-for="(val, key) in langState.list" class="font-poppins-regular text-center w-100 btn btn-outline-dark" @click="handleChangeLang(key)">{{val}}</button>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, reactive, onMounted, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import { useI18n } from 'vue-i18n';

import { measureNetworkSpeed } from "../utils/speed";
import { getBalance } from '../services/helper/utils';
import { getActiveRound } from '../services/api/round';
import { getUserPoint } from '../services/api/user';
import ChainApi from '../services/wallet/ChainApi';
import NetworkDelay from '../components/NetworkDelay';

export default {
  name: 'Header', 
  
  props: {
    address: {
      type: String,
      default: ''
    },
    loginLoading: {
      type: Boolean,
      default: false
    },
  },

  components: {
    NetworkDelay,
  },

  setup(props, context) {
    const { locale } = useI18n();
    const toast = useToast();
    const route = useRoute();

    const showNav = ref(true);
    const walletState = reactive({
      address: props.address,
      balanceTxt: null,
      showDropdown: false,
      loginLoading: props.loginLoading,
      errorChain: false,
      point: null,
    });
    const langState = reactive({
      current: locale.value,
      list: {
        en_us: 'English',
        zh_tw: '繁体中文',
        ko_kr: '한국어',
        /*
        ja_jp: '日本語',
        fr_fr: 'Français',
        ru_ru: 'русский',
        tr_tr: 'Türkçe',
        vi_vn: 'Tiếng Việt',
        id_id: 'bahasa Indonesia',
        */
      },
      showList: false,
    });

    const coImgId = ref(null);

    const chainApi = ChainApi;

    let balanceTimeout = null;
    let pointTimeout = null;

    const connectWallet = async(to = null) => {
      context.emit('connectWallet', to);
    }

    const disconnectWallet = () => {
      walletState.showDropdown = false;
      
      context.emit('disconnectWallet');
    }

    const balanceTimer = async() => {
      if(walletState.address) {
        let tempDct = chainApi.chainWeb3.getDefaultCostToken();
        if(tempDct) {
          let tempBalance = await getBalance(walletState.address, tempDct.address);
          let tempFromWei = await Number(chainApi.chainWeb3.web3.utils.fromWei(tempBalance));
          tempBalance = Math.floor(tempFromWei * 100) / 100;
          walletState.balanceTxt = tempDct.name + ': ' + tempBalance;
          sessionStorage.setItem('superAvatarSymbol', tempDct.name);
          sessionStorage.setItem('superAvatarBalance', tempBalance);
        }

        balanceTimeout = setTimeout(() => {
          balanceTimer();
        }, 10000);
      }
      else {
        clearTimeout(balanceTimeout);
        balanceTimeout = null;
      }
    }

    const pointTimer = async() => {
      if(walletState.address) {
        await getUserPoint(walletState.address)
        .then(res => {
          let data = res.data;
          if(data.status == 10000) {
            walletState.point = data.result.allPoint
          }
        })

        pointTimeout = setTimeout(() => {
          pointTimer();
        }, 15000);
      }
      else {
        clearTimeout(pointTimeout);
        pointTimeout = null;
      }
    }

    const handleChangeLang = (tgt) => {
      locale.value = tgt;
      langState.current = tgt;
      langState.showList = false;
      localStorage.setItem('superAvatarLang', tgt);
    }

    const closeWalletDropDown = () => {
      walletState.showDropdown = false;
    }

    const handleChainChanged = async() => {
      let tempCid = await chainApi.chainWeb3.web3.eth.getChainId();
      if(tempCid != 0 && tempCid != 56 && tempCid != 97) {
        walletState.errorChain = true;
      }
      else {
        walletState.errorChain = false;
      }
    }

    const navInit = () => {
      let screenWidth = window.innerWidth || document.documentElement.clientWidth;

      showNav.value = (screenWidth > 1000);
    }

    onMounted(async() => {
      navInit();

      await getActiveRound()
      .then(async(res) => {
        let data = res.data;
        if(data.code == 0) {
          coImgId.value = ((data.data.client_round_id - 1) % 10 + 1);
        }
      });

      window.addEventListener('click', closeWalletDropDown);
      window.addEventListener('resize', navInit);

      window.addEventListener('customChainChanged', handleChainChanged, false);

    })

    onUnmounted(() => {
      clearTimeout(pointTimeout);
      pointTimeout = null;

      clearTimeout(balanceTimeout);
      balanceTimeout = null;

      window.removeEventListener('click', closeWalletDropDown);
      window.removeEventListener('resize', navInit);
    })

    watch(() => props.address, (newVal, oldVal) => {
      walletState.address = newVal;
      if(newVal) {
        balanceTimer();
        pointTimer();
      }
    });

    watch(() => props.loginLoading, (newVal, oldVal) => {
      walletState.loginLoading = newVal;
    });

    watch(route, (newVal, oldVal) => {
      navInit();
    })

    return {
      showNav,
      handleChangeLang,
      connectWallet,
      disconnectWallet,
      walletState,
      langState,
      coImgId,
    }
  }
}
</script>

<style>
header .logo-box {
  flex: 1;
}

header .logo {
  height: 32px;
}

header .co-branded {
  margin-left: 20px;
}

header .co-logo {
  height: 22px;
}

header .toggle-nav-btn {
  display: none;
}

.nav-space {
  display: none;
}

nav .btn:hover path,
.wallet-box .dropwodn-open,
.lang-box:hover path {
  fill: #fff;
}

nav .btn {
  font-size: 0.9rem;
}

.network-hint {
  font-size: 0.8rem;
  top: 2.1rem;
  left: 50%;
  transform: translateX(-50%);
}

.wallet-box .dropwodn-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.wallet-box .wallet-addr-btn {
  min-width: 155px;
}

.wallet-dropdown-menu {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 3;
}

.lang-list-box {
  display: none;
  width: 180px;
  right: 0;
  z-index: 3;
}

.lang-list {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #333;
  border-radius: 5px;
  overflow-y: auto;
}

.lang-box:hover .lang-list-box {
  display: block;
}

.lang-list .btn {
  border: none;
  border-radius: 0;
  border-top: 1px solid #333;;
}

.lang-list .btn:first-child {
  border-top: none;
}

@media (max-width: 1150px) {
  header .logo {
    height: 20px;
  }

  header .co-branded {
    margin-left: 8px;
  }
}

@media (max-width: 1000px) {
  header .header-box {
    align-items: baseline;
  }

  header .logo {
    height: 20px;
    margin-bottom: 8px;
  }

  header .co-branded {
    margin-bottom: 8px;
    margin-left: 20px;
  }

  header .co-logo {
    height: 20px;
  }

  header .toggle-nav-btn {
    display: block;
    z-index: 3;
  }

  header .nav-box {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 5;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    overflow-y: auto;
  }

  header .nav-box .toggle-nav-btn {
    right: 10px;
    top: 10px;
    width: auto;
  }

  header .nav-space,
  header .nav {
    height: 100vh;
    display: block;
    overflow-y: auto;
  }

  header .nav-space {
    flex: 1;
  }

  header .nav {
    background: #fff;
    width: 300px;
    display: block;
    padding-top: 65px;
    overflow-y: auto;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    overflow: hidden;
    background-repeat: repeat-x;
    background-size: auto 100%;
    background-position: center center;
    background-image: url('../assets/images/modal_bg.jpg');
  }

  header nav .nav-item,
  header nav a,
  header nav .btn {
    width: 100%;
    margin-right: 0;
    text-align: left;
    border: none;
    border-radius: 0;
  }

  header nav a,
  header nav .btn {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  header .wallet-dropdown-menu,
  header .lang-list-box {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    padding-top: 0;
    font-size: 16px;
  }

  header nav .menu {
    display: block;
  }
}
</style>
